/** Internal type. DO NOT USE DIRECTLY. */
type Exact<T extends { [key: string]: unknown }> = { [K in keyof T]: T[K] };
/** Internal type. DO NOT USE DIRECTLY. */
export type Incremental<T> = T | { [P in keyof T]?: P extends ' $fragmentName' | '__typename' ? T[P] : never };
import * as Types from '~/common/types/graphql.ts';

import { TypedDocumentNode as DocumentNode } from '@graphql-typed-document-node/core';
export type CnutDataImportJobDiagnosisRuleType =
  | 'data_source_schema_mismatch'
  | 'invalid_composer_data_source'
  | 'invalid_composition_schema'
  | 'invalid_evidence_field_reference'
  | 'invalid_record_update_override'
  | 'invalid_relation_resolver'
  | 'invalid_select_value_range'
  | 'not_ready_data_source_rows'
  | 'unmapped_data_source_fields'
  | 'unmapped_evidence_fields';

export type CnutDataImportJobDiagnosisSeverity =
  | 'error'
  | 'info'
  | 'ok'
  | 'warning';

export type CnutDataImportJobDiagnosisStatus =
  | 'completed'
  | 'failed'
  | 'pending'
  | 'running';

export type CnutListDataImportJobDiagnosesInput = {
  dataImportProjectId: string;
  limit?: number | null | undefined;
  tenantId: string;
};

export type ListDataImportJobDiagnosesQueryVariables = Exact<{
  input: Types.CnutListDataImportJobDiagnosesInput;
}>;


export type ListDataImportJobDiagnosesQuery = { cnutListDataImportJobDiagnoses: Array<{ __typename: 'CnutDataImportJobDiagnosis', id: string, projectId: string, status: Types.CnutDataImportJobDiagnosisStatus, requestedBy: string, requestedAt: string, completedAt: string | null, summary: string | null, errorMessage: string | null, results: Array<{ __typename: 'CnutDataImportJobDiagnosisRuleResult', ruleType: Types.CnutDataImportJobDiagnosisRuleType, severity: Types.CnutDataImportJobDiagnosisSeverity, target: string, message: string, details: Types.JsonObject, suggestion: string }> }> };


export const ListDataImportJobDiagnosesDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"ListDataImportJobDiagnoses"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"input"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"CnutListDataImportJobDiagnosesInput"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"cnutListDataImportJobDiagnoses"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"input"},"value":{"kind":"Variable","name":{"kind":"Name","value":"input"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"projectId"}},{"kind":"Field","name":{"kind":"Name","value":"status"}},{"kind":"Field","name":{"kind":"Name","value":"requestedBy"}},{"kind":"Field","name":{"kind":"Name","value":"requestedAt"}},{"kind":"Field","name":{"kind":"Name","value":"completedAt"}},{"kind":"Field","name":{"kind":"Name","value":"results"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"ruleType"}},{"kind":"Field","name":{"kind":"Name","value":"severity"}},{"kind":"Field","name":{"kind":"Name","value":"target"}},{"kind":"Field","name":{"kind":"Name","value":"message"}},{"kind":"Field","name":{"kind":"Name","value":"details"}},{"kind":"Field","name":{"kind":"Name","value":"suggestion"}}]}},{"kind":"Field","name":{"kind":"Name","value":"summary"}},{"kind":"Field","name":{"kind":"Name","value":"errorMessage"}}]}}]}}]} as unknown as DocumentNode<ListDataImportJobDiagnosesQuery, ListDataImportJobDiagnosesQueryVariables>;